export const SEX_LABEL: Record<string, string> = {
  m: 'Male',
  f: 'Female',
};

export const ECONOMIC_ACTIVITY_LABEL: Record<string, string> = {
  employed: 'Employed',
  self_employed: 'Self-employed',
  unemployed: 'Unemployed',
  student: 'Student',
  retired: 'Retired',
  inactive_other: 'Inactive',
};

export const COMPOSITION_LABEL: Record<string, string> = {
  single_adult: 'Single adult',
  couple_no_children: 'Couple, no children',
  couple_with_children: 'Couple with children',
  single_parent: 'Single parent',
  multi_adult: 'Multi-adult',
  other: 'Other',
};

export const TENURE_LABEL: Record<string, string> = {
  owned_outright: 'Owned outright',
  owned_mortgage: 'Owned with mortgage',
  social_rented: 'Social rented',
  private_rented: 'Private rented',
  other: 'Other',
};

export const COUNTRY_LABEL: Record<string, string> = {
  england: 'England',
  wales: 'Wales',
  scotland: 'Scotland',
  northern_ireland: 'Northern Ireland',
};
